var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraniteQuartzaCountertops(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5736 35.1521C13.4877 35.0567 13.4209 34.9517 13.335 34.8658L2.26332 23.775C2.16787 23.6795 2.06288 23.5936 2.00562 23.5459L6.31976 19.0504L6.59655 19.2986L22.0969 34.8753L22.3547 35.1521H13.5736Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.468994 13.2664C0.568675 13.1921 0.66426 13.1125 0.755331 13.0278L11.8748 1.90839C11.9457 1.83571 12.0126 1.75925 12.0752 1.67932L16.5707 5.98393L16.3034 6.27981L0.726698 21.7897L0.468994 22.0188V13.2664Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.468994 0.152222H10.7103L10.529 0.362204L0.65034 10.2504C0.595911 10.3053 0.535018 10.3534 0.468994 10.3936V0.152222Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.468994 24.8917C0.543137 24.9437 0.613324 25.0012 0.678976 25.0635L10.5576 34.9422C10.62 35.0078 10.6774 35.078 10.7294 35.1521H0.468994V24.8917Z",
    fill: "black"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2275 35.1522C25.2944 35.0758 25.3516 34.9899 25.4184 34.9231L35.2112 25.1304C35.278 25.054 35.3543 24.9967 35.4784 24.8822V35.1522H25.2275Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9228 11.7488L29.7422 16.1297L13.5737 0.1521H13.9746H22.0398C22.2051 0.153539 22.3644 0.214535 22.4884 0.323902L33.875 11.701L33.9228 11.7488Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5261 13.3332V13.6291C35.5261 16.3207 35.5261 19.0027 35.5261 21.6943C35.5152 21.8668 35.4481 22.0311 35.3352 22.1619L23.9771 33.4818L23.8626 33.5868L19.5007 29.4063L35.402 13.295L35.5261 13.3332Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0023 7.55872L28.0337 17.5996L23.7482 21.8947L13.7073 11.8538L18.0023 7.55872Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.9043 17.6474L12.1707 13.381L22.2402 23.4505L17.9738 27.7169L7.9043 17.6474Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3325 0.1521H35.4689V10.2884L25.3325 0.1521Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraniteQuartzaCountertops);
export default __webpack_public_path__ + "static/media/granite-quartza-countertops.d68fc161c26ea0751dd19947481f5ee9.svg";
export { ForwardRef as ReactComponent };